import { Component, OnInit } from '@angular/core';
import { Fur } from 'src/app/models/Fur';
import { TipoAtencionService } from 'src/app/services/tipo-atencion.service';
import { TipoAtencion } from 'src/app/models/TipoAtencion';
import { iconBuscar } from 'src/app/general/variables';
import { Canal } from 'src/app/models/Canal';
import { CanalService } from 'src/app/services/canal.service';
import { Denunciante } from 'src/app/models/Denunciante';

@Component({
  selector: 'app-datos-gen-fur',
  templateUrl: './datos-gen-fur.component.html',
  styleUrls: ['./datos-gen-fur.component.css']
})
export class DatosGenFurComponent implements OnInit {

  flgLectura = false;
  fur: Fur = new Fur();
  listTipoAtencion: TipoAtencion[] = [];
  listCanal: Canal[] = [];
  iconBuscar = iconBuscar;
  strNumDenuncianteId = '';

  constructor(protected tipoAtencionServicie: TipoAtencionService,
              protected canalServicie: CanalService) { }

  ngOnInit() {

    this.tipoAtencionServicie.listarTipoAtencion().subscribe(data => {

      this.listTipoAtencion = data;

    });

    this.canalServicie.listarCanal().subscribe(data => {

      this.listCanal = data;

    });

  }

  // _getActivaBusqExp(){




  // }

  setDatosGenFurC(furFW: Fur) {

    const vDenunciante: Denunciante = furFW.denunciante;

    this.fur = furFW;

    if (vDenunciante != null) {

      this.strNumDenuncianteId = vDenunciante.ndenuncianteId.toString();

    }

  }

  // _buscarExpediente(){



  // }

}
